import { listBookings, getBooking } from '@/services/academy/bookings.service'

export default {
	namespaced: true,
	state: {
		list: { data: [], meta: { total: 0 } },
		booking: {},
		listStatus: 'init',
	},
	getters: {
		getList: (s) => s.list,
		getBooking: (s) => s.booking,
		getListStatus: (s) => s.listStatus,
	},
	mutations: {
		SET_LIST(state, v)        { state.list = v },
		SET_BOOKING(state, v)     { state.booking = v },
		SET_LIST_STATUS(state, v) { state.listStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listBookings(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async fetchBookingByID({ commit }, id) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await getBooking(id)
				commit('SET_BOOKING', data.data ?? data)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
	},
}
